export const SOFT_DELETE_USER = `
  mutation softDeleteUser {
    softDeleteUser {
      userId
    }
  }
`;
